import React from "react";
import Skeleton from "react-loading-skeleton";
import { View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "./Skeletons";
import { AppColors } from "../../utility/AppColors";
import { s } from "react-native-size-matters";

const SearchResultSkeleton = () => {
  const deviceSize = useDeviceSize();
  let skeletonCards = Array(5).fill(0);
  return (
    <View
      style={{
        flexDirection: "column",
        width: "50%",
        gap: 10,
        paddingTop: 12,
        paddingBottom: 35,
      }}
    >
      <Skeletons
        height={20}
        width={
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? "150px"
            : "185px"
        }
        style={{
          borderRadius: 10,
        }}
      />
      <View
        style={{
          flexDirection: "row",
          width: "50%",
          gap: 5,
        }}
      >
        {skeletonCards.map((index) => (
          <Skeletons
            height={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 22
                : 35
            }
            width={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? "82px"
                : "97px"
            }
            style={{
              borderRadius: 50,
            }}
          />
        ))}
      </View>
    </View>
  );
};

export default SearchResultSkeleton;
